import React, { useEffect, useState } from "react";

import Loading from "../../callback/loading";

import { getBins } from "../lib/binData";
import { getShipment } from "../lib/shipmentData";
import { ShipmentProvider } from "./index";
import { useShipmentUpcs } from "../hooks/use-shipment-upcs";
import { SHIPMENT_TYPE_MAP } from "../../shipments/lib/constants";
import { BRAND_VERIFIED_WORKFLOW_TYPE_ID } from "../lib/constants";

const Shipment = (props) => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [shipmentData, setShipmentData] = useState({});
    const [bins, setBins] = useState([]);
    const [hasProducts, setHasProducts] = useState(false);
    const [isInDuplicateStaging, setIsInDuplicateStaging] = useState(false);
    const { data: upcTasks, refetch: refetchShipmentUpcs } = useShipmentUpcs(props.shipmentKey);

    useEffect(() => {
        fetchShipment();
    }, []);

    const assignBin = (shipment, storedBins) => {
        if (SHIPMENT_TYPE_MAP[shipment.shipmentType].isDigital) {
            return shipment.workflowTypeId === BRAND_VERIFIED_WORKFLOW_TYPE_ID
                ? [`BRANDVERIFIED-${props.shipmentKey}`]
                : [`DIG-${props.shipmentKey}`];
        }

        return storedBins ? storedBins : [];
    };

    const fetchShipment = async () => {
        const shipment = await getShipment(props.shipmentKey);
        const storedBins = await getBins(props.shipmentKey);
        const hasFinalizedUpc = await canEditShipmentAsync(props.shipmentKey);
        shipment.hasFinalizedUpc = hasFinalizedUpc;

        setShipmentData(shipment);
        setBins(assignBin(shipment, storedBins));
        setIsInDuplicateStaging(shipment.isInDuplicateStaging);
        setIsLoaded(true);
    };

    const canEditShipmentAsync = async (key) => {
        if (key) {
            try {
                refetchShipmentUpcs();

                return upcTasks.filter((upc) => upc.isFinalized).length > 0;
            } catch (e) {
                return false;
            }
        }

        return false;
    };

    const updateShipmentData = (data) => {
        setShipmentData(data);
    };

    const updateBins = (newBins) => {
        setBins([...newBins]);
    };

    const updateHasProducts = (value) => {
        setHasProducts(value);
    };

    const refreshUpcs = () => {
        return refetchShipmentUpcs();
    };

    if (!isLoaded) {
        return <Loading />;
    }

    return (
        <ShipmentProvider
            value={{
                bins,
                hasProducts,
                shipmentData,
                updateBins,
                updateHasProducts,
                updateShipmentData,
                refreshUpcs,
                upcTasks,
                isInDuplicateStaging,
            }}
        >
            {props.children}
        </ShipmentProvider>
    );
};

export default Shipment;
